import { gtmConfigurationDictionary } from '../constants';
import type { GtmConfig, GtmConfigurationDictionary } from '../types';

export const getGtmContainerWithLocale = (): GtmConfig => {
    const locale = process.env.NEXT_PUBLIC_LOCALE ?? 'en-US';

    return gtmConfigurationDictionary[
        locale as keyof GtmConfigurationDictionary
    ];
};
